/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : Dashboard.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import React from "react";
import { Outlet } from "react-router-dom";
import CustomLoaderDialog from "../components/dialog-boxes/CustomSpinner";
import { useDispatch, useSelector } from "react-redux";
import TopBar from "./TopBar/TopBar";
import SideBar from "./SideBar/SideBar";
import { Box } from "@mui/material";
import { ChatWidgetComponent } from '@neubinary/chat-widget-neusage';
import { HandleApiActions } from "../redux/actions/actionHandler";
import profileActions from "../redux/actions/profile";
import settingsApis from "../redux/actions/settings";

export default function Dashboard() {
  const dispatch = useDispatch();
  const [openProgressBar, setOpenProgressBar] = React.useState(false);
  const spinnerState = useSelector((state) => state.spinnerReducer);
  const profileDetails = useSelector((store) => store.profileReducer);

  const data = profileDetails?.profile?.email
    ? {
      apiUrl: "https://neusage.neubinary.com/",
      user: {
        name: "admin",
        email: "admin@gmail.com",
        id: profileDetails?.profile?.id,
        phone: profileDetails?.profile?.phone,
      },
      organization: {
        id: "9f307743-1167-48e5-a53c-024e485ce6f5",
        name: "Deloitte",
      },
      skipValidation: false,
      channel_id: "298e8e47-575e-4cd4-8173-688a4f567f31",
    }
    : null;

  React.useEffect(() => {
    dispatch(HandleApiActions({ ...settingsApis.get_app_meta_data }));
  }, []);

  React.useEffect(() => {
    dispatch(HandleApiActions({ ...profileActions.get_profile_details }));
  }, []);
  const startTimeRef = React.useRef(0);

  React.useEffect(() => {
    if (spinnerState.isLoading) {
      startTimeRef.current = Date.now();
      setOpenProgressBar(true);
    } else {
      const elapsed = Date.now() - startTimeRef.current;
      const delay = Math.max(500 - elapsed, 0);

      setTimeout(() => {
        setOpenProgressBar(false);
      }, delay);
    }
  }, [spinnerState]);
  return (
    <Box
      sx={{
        width: "100vW",
        height: "100vH",
        maxWidth: "100vw",
        maxHeight: "100vh",
        overflow: "hidden",
        backgroundColor: "whitesmoke", // For visibility, you can remove or change this
      }}
    >
      <TopBar />

      <div className="app">
        <SideBar />

        <Box
          sx={{
            width: "95vw",
            height: "95vh",
            maxWidth: "95vW",
            maxHeight: "95vH",
            overflow: "auto",
            margin: 0,
            padding: 0,
          }}
          className="container"
        >
          <main className="content">
            <Outlet />
          </main>
        </Box>
        {openProgressBar && (
          <CustomLoaderDialog
            open={openProgressBar}
            handleClose={() => setOpenProgressBar(false)}
          />
        )}
        {data && <ChatWidgetComponent config={data} />}
      </div>
    </Box>
  );
}
